import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog, CommandInput, CommandList, CommandEmpty,
  CommandGroup, CommandItem,
} from "@/components/ui/command";
import {
  LayoutDashboard, Globe, Server, FolderTree, Link2, Route, Archive,
  Activity, ScrollText, Users, SlidersHorizontal, Settings, Plus, Cloud, Network,
} from "lucide-react";
import api from "@/lib/api";

const PAGES = [
  { label: "Dashboard", to: "/", icon: LayoutDashboard },
  { label: "Sites", to: "/sites", icon: Globe },
  { label: "Apps", to: "/apps", icon: Server },
  { label: "Files", to: "/files", icon: FolderTree },
  { label: "Links", to: "/links", icon: Link2 },
  { label: "Cloud Run", to: "/cloudrun", icon: Cloud },
  { label: "AWS Hosting", to: "/aws", icon: Cloud },
  { label: "FreeDNS", to: "/freedns", icon: Network },
  { label: "Routing", to: "/routing", icon: Route },
  { label: "Backups", to: "/backups", icon: Archive },
  { label: "Monitoring", to: "/monitoring", icon: Activity },
  { label: "Logs", to: "/logs", icon: ScrollText },
  { label: "Users", to: "/users", icon: Users },
  { label: "Server Control", to: "/server", icon: SlidersHorizontal },
  { label: "Settings", to: "/settings", icon: Settings },
];

export function CommandPalette({ open, setOpen }) {
  const navigate = useNavigate();
  const [sites, setSites] = useState([]);

  useEffect(() => {
    if (open) api.get("/sites").then(setSites).catch(() => {});
  }, [open]);

  const go = (to) => { setOpen(false); navigate(to); };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Jump to page or search sites…" data-testid="command-input" />
      <CommandList>
        <CommandEmpty>No results.</CommandEmpty>
        <CommandGroup heading="Actions">
          <CommandItem onSelect={() => go("/sites?new=1")}>
            <Plus className="mr-2 h-4 w-4" /> Deploy Site / App
          </CommandItem>
        </CommandGroup>
        <CommandGroup heading="Navigation">
          {PAGES.map((p) => (
            <CommandItem key={p.to} onSelect={() => go(p.to)}>
              <p.icon className="mr-2 h-4 w-4" /> {p.label}
            </CommandItem>
          ))}
        </CommandGroup>
        {sites.length > 0 && (
          <CommandGroup heading="Sites">
            {sites.slice(0, 8).map((s) => (
              <CommandItem key={s.slug} onSelect={() => go(`/files?site=${s.slug}`)}>
                <Globe className="mr-2 h-4 w-4" /> {s.name}
                <span className="ml-auto font-mono text-xs text-zinc-500">{s.slug}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
